var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#262C2E",
    d: "M8 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0M11 15a1 1 0 1 1 2 0 1 1 0 0 1-2 0M14 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M20 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0M17 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0M5 15a1 1 0 1 1 2 0 1 1 0 0 1-2 0M2 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.88a8a40938a789ece018de94e024a1ca.svg";
export { ForwardRef as ReactComponent };